<div class="container">
    <div class="row">
        <div class="col-md-12" style="text-align: center;">
            <img src="./assets/images/404.png" >
        </div>
    </div>
</div>